import company from './de/company'
import nav from './de/nav'
import footer from './de/footer'
import talentProfileEnums from './de/talentProfileEnums'
import hotlistDeclineReason from './de/hotlistDeclineReason'
import faq from './de/faq'
import applicationEnums from './de/applicationEnums'
import positionFields from './de/positionFields'
import formats from '~/locales/de/formats'
import jobDescriptionEnum from './de/jobDescriptionEnum'
import hotlist from './de/hotlist'
import applicants from './de/applicants'
import login from '~/locales/de/login'
import firebaseError from '~/locales/de/firebaseError'
import countries from '~/locales/de/countries'
import calculator from '~/locales/de/calculator'

export default (context, locale) => {
  return {
    yes: 'Ja',
    no: 'Nein',
    ok: 'Ok',
    cancel: 'Abbrechen',
    close: 'Schließen',
    continue: 'Weiter',
    confirm: 'Bestätigen',
    save: 'Speichern',
    done: 'Fertig',
    send: 'Senden',
    apply: 'Bewerben',
    next: 'Weiter',
    back: 'Zurück',
    later: 'Später',
    start: 'Beginnen',
    nav,
    footer,
    company,
    talentProfileEnums,
    applicationEnums,
    hotlistDeclineReason,
    positionFields,
    faq,
    formats,
    jobDescriptionEnum,
    hotlist,
    applicants,
    login,
    firebaseError,
    countries,
    calculator,
  }
}
